import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckCircle, XCircle } from 'lucide-react';
/**
 * StatusBadge Component
 * Displays a colored badge indicating active or inactive status
 */
export function StatusBadge({ isActive, activeLabel = 'Active', inactiveLabel = 'Inactive', showIcon = true, size = 'md', }) {
    const sizeClasses = {
        sm: 'px-2 py-0.5 text-xs',
        md: 'px-2.5 py-1 text-xs',
        lg: 'px-3 py-1.5 text-sm',
    };
    const iconSizes = {
        sm: 'w-3 h-3',
        md: 'w-3.5 h-3.5',
        lg: 'w-4 h-4',
    };
    if (isActive) {
        return (_jsxs("span", { className: `inline-flex items-center gap-1 ${sizeClasses[size]} rounded-full font-medium bg-success-100 text-success-800 dark:bg-success-900 dark:text-success-200`, children: [showIcon && _jsx(CheckCircle, { className: iconSizes[size] }), activeLabel] }));
    }
    return (_jsxs("span", { className: `inline-flex items-center gap-1 ${sizeClasses[size]} rounded-full font-medium bg-danger-100 text-danger-800 dark:bg-danger-900 dark:text-danger-200`, children: [showIcon && _jsx(XCircle, { className: iconSizes[size] }), inactiveLabel] }));
}
/**
 * Helper function to get status badge (for use in table render functions)
 * @deprecated Use StatusBadge component directly
 */
export function getStatusBadge(entity) {
    return _jsx(StatusBadge, { isActive: entity.isActive });
}
